import $ from "jquery";
export class cuttingSliderModule {

	constructor(event, slick, statement) {
		statement === "init"
			? this.handleInit(slick)
			: (statement === "beforeChange"
				? this.handleBeforeChange(slick)
				: (statement === "afterChange"
					? this.handleAfterChange(slick)
					: this.Vasilkov()));
	}
	private Vasilkov = () => {

		setTimeout(function () {
			$('.cutting').css('opacity', '1');
		}, 900)
	}
	private handleInit(slick) {
		// console.log('afterChange/init', event, slick, slick.$slides);
		// remove all prev/next
		slick.$slides.removeClass('prevSlide').removeClass('nextSlide');

		// find current slide
		for (var i = 0; i < slick.$slides.length; i++) {
			var $slide = $(slick.$slides[i]);

			if ($slide.hasClass('slick-current')) {
				// update DOM siblings
				$slide.prev().addClass('prevSlide');
				$slide.next().addClass('nextSlide');
				break;
			}
		}



	}
	private handleAfterChange(slick) {
		// console.log('afterChange/init', event, slick, slick.$slides);
		// remove all prev/next
		slick.$slides.removeClass('prevSlide').removeClass('nextSlide');

		// find current slide
		for (var i = 0; i < slick.$slides.length; i++) {
			var $slide = $(slick.$slides[i]);

			if ($slide.hasClass('slick-current')) {
				// update DOM siblings
				$slide.prev().addClass('prevSlide');
				$slide.next().addClass('nextSlide');
				break;
			}
		}



	}
	private handleBeforeChange(slick) {
		slick.$slides.removeClass('prevSlide').removeClass('nextSlide');
	}

	//if needed without vue can methods be converted to plain jquery, events can be seen here: https://kenwheeler.github.io/slick/
	//any questions, ask Anders Bootsmann.

}
